










import { defineComponent, PropType, ref, toRefs } from '@nuxtjs/composition-api'

import useFilterBarItem from '@/composables/use-filter-bar-item'
import CustomSelectItem from '@/interfaces/CustomSelectItem'
import { tdCarFilterPc } from '@/modules/ga4'

export default defineComponent({
  props: {
    value: {
      type: String as PropType<string | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,
    } = useFilterBarItem(toRefs(props).value, emit)

    const clickSave = () => {
      saveAndHide()

      tdCarFilterPc({
        age: selectedItem.value ? selectedItem.value.name : '',
      })
    }
    const clickClear = () => {
      clear()
    }

    const selectedItem = ref<CustomSelectItem>()
    const onUpdate = (value: CustomSelectItem) => {
      selectedItem.value = value
    }

    return {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clear,
      clickSave,
      clickClear,
      onUpdate,
    }
  },
})
